module.exports = __webpack_public_path__ + "img/bait_no.88bd9309.png";